module.exports = __webpack_public_path__ + "img/c03e087.jpg";